var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1980_6505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1980_6505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33268 26.6654C4.59935 26.6654 3.97157 26.4043 3.44935 25.882C2.92713 25.3598 2.66602 24.732 2.66602 23.9987V7.9987C2.66602 7.26536 2.92713 6.63759 3.44935 6.11536C3.97157 5.59314 4.59935 5.33203 5.33268 5.33203H26.666C27.3993 5.33203 28.0271 5.59314 28.5493 6.11536C29.0716 6.63759 29.3327 7.26536 29.3327 7.9987V23.9987C29.3327 24.732 29.0716 25.3598 28.5493 25.882C28.0271 26.4043 27.3993 26.6654 26.666 26.6654H5.33268ZM15.9993 17.332L26.666 10.6654V7.9987L15.9993 14.6654L5.33268 7.9987V10.6654L15.9993 17.332Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fbfbe3e82dd1f38cd1898988b8f53945.svg";
export { ForwardRef as ReactComponent };